var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-banner"},[_c('div',{staticClass:"c-banner__container"},[_c('p',{staticClass:"c-banner__heading"},[_vm._t("heading")],2),_c('p',{staticClass:"c-banner__message"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }